import React from "react";
import { usePathname, useSearchParams } from "next/navigation";

import useDomain from "../../hooks/useDomain";

function ReportProblemMailer({ wrapperClasses }: { wrapperClasses?: string }) {
  const searchParams = useSearchParams();
  const asPath = usePathname();
  const domain = useDomain();

  const query = searchParams?.toString();

  const url = query ? `${domain}${asPath}?${query}` : `${domain}${asPath}`;

  return (
    <div className={wrapperClasses}>
      Notice a problem?
      <a
        className="underline ml-xs"
        style={{ fontWeight: 600 }}
        href={`mailto:reportaconcern@leafly.com?subject=Report a concern&body=Reporting a concern with ${url}.`}
      >
        Report this item
      </a>
    </div>
  );
}

export default ReportProblemMailer;
